import { REACT_APP_UMS_URL, API_UMS_URL } from "./const";
import { isEmpty } from "lodash";

export function getUmsDashboardUrl() {
  const REACT_ENV = process.env.NODE_ENV;
  const SANCTIONS_URL = !!process.env.REACT_APP_UMS_URL && process.env.REACT_APP_UMS_URL !== "" ? process.env.REACT_APP_UMS_URL : REACT_APP_UMS_URL;
  if (!isEmpty(REACT_ENV)) {
    return SANCTIONS_URL;
  } else {
    return REACT_APP_UMS_URL;
  }
}

export const getUmsDashboardValue = () => {
  return getUmsDashboardUrl();
};

const umsApiUrl = () => {
  const REACT_ENV = process.env.NODE_ENV;
  const SANCTIONS_URL = !!process.env.REACT_APP_UMS_URL && process.env.REACT_APP_UMS_URL !== "" ? process.env.REACT_APP_UMS_URL : API_UMS_URL;
  if (!isEmpty(REACT_ENV)) {
    return SANCTIONS_URL;
  } else {
    return API_UMS_URL;
  }
};

export const getUmsApiUrl = (path) => {
  return `${umsApiUrl()}trademo/auth/${path}`;
};
